import { useCallback } from 'react';

import { fetchSearchVacancies } from '../../../services';
import {
  VacanciesResponseInterface,
  VacanciesSearchRequestInterface,
} from '../../../types/vacancies.types';
import { ApiServiceType, useApiService } from '../useApiService';
import { useVacanciesLinkTransformer } from '../useVacanciesLinkTransformer';

import { FetchVacanciesHookType } from './useFetchVacancies.types';

export const useFetchVacancies: FetchVacanciesHookType = ({
  searchFilter,
  immediateExecute,
} = {}) => {
  const service: ApiServiceType<VacanciesSearchRequestInterface, VacanciesResponseInterface> =
    useCallback(
      ({ requestData, abortController } = {}) => fetchSearchVacancies(requestData, abortController),
      []
    );
  const linkTransformer = useVacanciesLinkTransformer();

  const serviceResult = useApiService<VacanciesSearchRequestInterface, VacanciesResponseInterface>({
    service,
    initialServiceRequestData: searchFilter,
    responseTransformers: linkTransformer,
    immediateExecute,
  });

  return {
    ...serviceResult,
    fetchVacancies: serviceResult.executeCall,
    vacancies: serviceResult.response?.vacancies ?? [],
  };
};
